import { render, staticRenderFns } from "./SingleTagDashboard.vue?vue&type=template&id=11df0c9c&scoped=true&"
import script from "./SingleTagDashboard.vue?vue&type=script&lang=js&"
export * from "./SingleTagDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SingleTagDashboard.vue?vue&type=style&index=0&id=11df0c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11df0c9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
